var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.shortenedText)}}),_c('v-btn',{attrs:{"small":"","text":"","color":"primary"},on:{"click":_vm.toggleExpanded}},[_vm._v(" "+_vm._s(_vm.expanded ? 'Show Less' : 'Read More')+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }